var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }